import PropTypes from "prop-types";
import { useRef, useCallback, useState } from "react";
import { AsyncTypeahead as BSAsyncTypeahead } from "react-bootstrap-typeahead";

import styles from "./AsyncTypeahead.module.scss";

const AsyncTypeahead = ({ className, clearOnChange, onChange, placeholder }) => {
  const ref = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const handleSearch = useCallback(async (query) => {
    setIsLoading(true);

    const cleanedQuery = query
      .normalize("NFD")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
    const response = await fetch(`/api/typeahead?q=${cleanedQuery}`);
    const data = await response.json();

    setOptions(data);
    setIsLoading(false);
  });

  // Bypass client-side filtering by returning `true`. Results are already
  // filtered by the search endpoint, so no need to do it again.
  const filterBy = () => true;

  return (
    <BSAsyncTypeahead
      className={className}
      filterBy={filterBy}
      id="async-typeahead"
      inputProps={{
        autoCapitalize: "off",
        autoCorrect: "off",
        spellCheck: false,
      }}
      isLoading={isLoading}
      labelKey="label"
      minLength={3}
      onChange={(e) => {
        if (e.length > 0 && e[0].length > 0) {
          ref.current.blur();
        }
        if (clearOnChange) {
          ref.current.clear();
        }
        onChange(e);
      }}
      onSearch={handleSearch}
      options={options}
      placeholder={placeholder}
      ref={ref}
      renderMenuItemChildren={(option) => {
        const srcPaths = option.image ? [option.image.slice(0, 1), option.image.slice(1, 2), option.image] : "";
        const src = option.image ? `https://cards.scryfall.io/art_crop/front/${srcPaths.join("/")}` : "";
        return (
          <div className="align-items-center d-flex justify-content-begin gap-2">
            {option.image ? (
              <span className={styles.left}>
                <div
                  className={styles.image}
                  style={{
                    backgroundImage: `url(${src})`,
                  }}
                />
              </span>
            ) : option.icon ? (
              <span className={styles.left}>
                <img alt={option.label} className={styles.icon} src={option.icon}></img>
              </span>
            ) : (
              <span className={styles.left}>&nbsp;</span>
            )}
            <span className={styles.right}>{option.label}</span>
          </div>
        );
      }}
    />
  );
};

AsyncTypeahead.propTypes = {
  className: PropTypes.string,
  clearOnChange: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default AsyncTypeahead;
